<div class="main-content">
  <div class="card">
    <div class="card-body">
      <div class="page-title">
        <span translate>NEWS</span>
      </div>
      <form [formGroup]="newsForm">
        <div class="form-group row">
          <div class="col-md-4">
            <label for="title" class="col-form-label">
              <span translate>TITLE</span>
            </label>
            <span class="required">*</span>
          </div>
          <div class="col-md-8">
            <input
              type="text"
              class="label-input form-control"
              formControlName="Title"
              [readonly]="!isEditor && !isAdmin"
            />
            <control-messages
              [control]="newsForm.controls['Title']"
            ></control-messages>
          </div>
        </div>
        <div class="form-group row">
          <div class="col-md-4">
            <label for="title" class="col-form-label">
              <span translate>EXPIRY_DATE</span>
            </label>
          </div>
          <div class="col-md-8">
            <p-datepicker
              [style]="{ width: '100%' }"
              formControlName="ExpiredOn"
              [showButtonBar]="true"
              [placeholder]="'SELECT_EXPIRY_DATE' | translate"
              [disabled]="!isEditor && !isAdmin"
              dateFormat="dd/mm/yy"
              [showIcon]="true"
              [minDate]="today"
            ></p-datepicker>
          </div>
        </div>

        <div class="mb-3">
          <h3 class="first">
            <span translate>CONTENT</span>
          </h3>
          <p-editor
            [readonly]="!isEditor && !isAdmin && !isUser"
            formControlName="ContentData"
            [style]="{ height: '320px' }"
          ></p-editor>

          <hr style="border-top: 0px; border-color: #dde3e6" />
        </div>
        <div class="action-btns-wrapper">
          <a [routerLink]="['../../../list']" class="btn btn-outline-secondary">
            <i class="pi pi-arrow-left"></i>
            <span translate>BACK_LIST</span>
          </a>
          <button
            *ngIf="isAdmin || isEditor"
            type="submit"
            class="btn btn-primary"
            (click)="clear()"
          >
            <span translate>CLEAR</span>
          </button>
          <button
            *ngIf="isAdmin || isEditor"
            type="submit"
            class="btn btn-primary"
            (click)="Save()"
            [disabled]="!newsForm.valid"
          >
            <span translate>SAVE</span>
          </button>
          <button
            *ngIf="isEditor && published"
            type="submit"
            class="btn btn-primary"
            (click)="SaveAndSendEmailToUsers()"
            [disabled]="!newsForm.valid || sendSMSToAllUser"
          >
            <span translate>PUBLISH_AND_SEND_EMAIL</span>
          </button>
          <button
            type="button"
            class="btn btn-primary"
            *ngIf="isAdmin && showPublishButton"
            [disabled]="!newsForm.valid || loading"
            (click)="SaveAndPublish()"
          >
            <span translate>PUBLISH_SEND_EMAIL_TO_THE_USERS</span>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<kuba-busy [busy]="loading" message="PROCESSING"></kuba-busy>

